const zh = {
  nav: { dashboard: "仪表板", localization: "本地化", industries: "行业", engagement: "运作方式", pricing: "价格", insights: "博客", about: "为何选择 Danny Clans", contact: "联系我们", professionalInquiry: "获取访问", hkIncorporated: "香港注册", language: "语言" },
  brand: { tagline: "扩展不可能", marketingLine: "我们扩展别人无法扩展的。", complianceLine: "香港特别行政区注册 • 合规", responsePromise: "2–3 小时回复" },
  cta: { primary: "获取访问", secondary: "探索仪表板", explore: "探索仪表板", submit: "提交专业咨询", talkToPartner: "联系合伙人", discussVertical: "讨论您的垂直领域", planMarketEntry: "规划市场进入", viewDetails: "查看仪表板功能", readPlaybook: "阅读手册", submitAnother: "再次提交", seePricing: "查看价格", exploreSolutions: "探索解决方案", seeVerticals: "查看行业垂直", discussRegion: "讨论 {{region}} 进入", buildEngine: "打造您的 {{vertical}} 引擎", discussModule: "讨论 {{module}}", read: "阅读" },
  home: {
    heroTitle: "一个仪表板。每个广告渠道。一个钱包。",
    heroSubtitle: "DC Dashboard 在 Meta、Google、TikTok、Bing、Snap、LinkedIn、YouTube、Outbrain、Taboola 等平台开通代理广告账户 — 由单一预付钱包提供资金,并从香港端到端管理。",
    heroPill1: { title: "代理级广告账户", desc: "一次申请。我们处理 KYC 和合规。" },
    heroPill2: { title: "一个钱包,任何渠道", desc: "银行、信用卡、UPI 或 Stablecoins — 为每个平台充值。" },
    heroPill3: { title: "审计就绪报告", desc: "实时交易、合规文档、导出。" },
  },
  stats: { enterprises: "服务的国际客户", markets: "覆盖的全球市场", adSpend: "每月广告支出", response: "咨询响应时间" },
  sections: {
    growthEngine:  { eyebrow: "DC Dashboard 内部", title: "五大能力。一个负责的控制台。", desc: "在每个主要渠道运营代理级广告账户所需的一切 — 从开通到合规。" },
    advantages:    { eyebrow: "为何选择 DC Dashboard", title: "为严肃的跨境广告主而建。", desc: "为专业媒介购买者提供不公平的优势 — 我们已将其构建到仪表板中。" },
    creative:      { eyebrow: "支持的渠道", title: "所有重要的广告渠道 — 集于一处。", desc: "从全球大平台到封闭的区域生态系统。一次申请,处处管理。" },
    regional:      { eyebrow: "本地化", title: "从一个仪表板运行区域原生活动。", desc: "每个地区都有自己的平台、支付、语言和法律。从单一控制台运行它们。" },
    industry:      { eyebrow: "行业解决方案", title: "垂直特定的进入市场系统。", desc: "品牌、游戏、应用、电商运营者 — 每个垂直都在 DC Dashboard 上运行。" },
    institutional: { eyebrow: "机构级可靠性", title: "运营证明,而非营销宣传。", desc: "可验证的监管信誉。香港注册、合规导向、审计就绪。" },
    why:           { eyebrow: "为何选择 Danny Clans Media", title: "低调自信。技术精湛。清新透明。", desc: "在一个以过度承诺闻名的行业中,我们以合规、基础设施和直接沟通领先。" },
    partners:      { caption: "在所有主要平台和区域生态系统中运营" },
    dashboard:     { eyebrow: "控制台内部", title: "DC Dashboard 一瞥。", desc: "钱包、交易、主广告账户和多通道存款 — 尽在一处。" },
    payments:      { eyebrow: "为钱包充值", title: "任何支付渠道。任何广告渠道。", desc: "电汇、信用卡、UPI 或 Stablecoins 入,Meta、Google、TikTok、Bing、Snap、LinkedIn、YouTube 等出。" },
    capabilities:  { eyebrow: "能力", title: "五大支柱。一个控制台。", desc: "为需要规模、合规和控制的跨境媒介购买者而建,无需同时处理 14 个平台。" },
    faq:           { eyebrow: "常见问题", title: "常见问题,直接回答。" },
    faqPricing:    { eyebrow: "常见问题", title: "常见的价格问题。" },
    engagementHow: { eyebrow: "DC Dashboard 工作方式", title: "从注册到规模化活动 — 五步。", desc: "在每个地区和行业垂直使用的有文档记录的入职路径。" },
    opPrinciples:  { eyebrow: "运营原则", title: "每个 Danny Clans 合作的保证。", desc: "我们不承诺具体的绩效指标。我们承诺这些。" },
    aboutPrinc:    { eyebrow: "运营原则", title: "指导每个 Danny Clans 合作的原则。", desc: "低调自信,技术精湛,清新透明。" },
    jurisdiction:  { eyebrow: "司法管辖与治理", title: "为何香港特区注册重要。", desc: "香港提供全球合规运营和全球认可 — 机构跨境合作伙伴的有意选择。" },
    whyPartner:    { eyebrow: "为何与我们合作", title: "经验丰富的运营者选择 Danny Clans Media 的六大理由。" },
  },
  ctaSection: {
    title: "准备好从一个仪表板运行每个渠道了吗?",
    subtitle: "申请代理级广告账户,为单一钱包充值,跨境扩展 — 端到端管理。",
    badge: "2–3 小时回复 · 保密",
    dashboardTitle: "从一个仪表板运行每个渠道。",
    pricingTitle: "获取书面范围和报价。",
    engagementTitle: "准备好加入 DC Dashboard 了吗?",
    industriesTitle: "为您的垂直领域打造跨境引擎。",
    aboutTitle: "保密对话,而非销售推销。",
    localizationTitle: "您接下来想在哪里成长?",
  },
  contact: {
    heroTitle: "联系 Danny Clans Media — 获取代理广告账户访问权限。",
    heroSubtitle: "直接、保密的咨询。告诉我们您的业务,我们将为您匹配合适的方案。",
    formTitle: "告诉我们您的项目",
    formHelp: "标有 * 的字段为必填项。我们在 2–3 小时内回复,香港工作日。",
    labels: { name: "全名 *", company: "公司 *", email: "工作邮箱 *", phone: "电话 (可选)", region: "主要关注地区", services: "感兴趣的服务", message: "项目背景 *" },
    placeholders: { name: "张三", company: "贵公司", email: "name@company.com", phone: "+852 …", message: "简要描述您的业务、目标市场和您想实现的目标。" },
    submitting: "提交中…",
    consent: "提交即表示您同意我们的保密咨询政策。",
    successTitle: "感谢您。我们将在 2–3 小时内回复。",
    successKicker: "已收到咨询",
    referenceLabel: "您的参考号:",
    successBody: "Danny Clans 合伙人将直接跟进。所有通信均保密。",
    sla: { kicker: "服务等级承诺", title: "2–3 小时回复", body: "高级 Danny Clans 合伙人亲自审核并回复。无机器人,无激进销售跟进。" },
    next: { title: "接下来会发生什么", items: ["确认与参考号", "保密接洽通话", "方案推荐与范围", "仪表板访问与启动"] },
    errors: { required: "必填", validEmail: "需要有效邮箱", minMessage: "至少 10 个字符", pleaseFill: "请填写必填字段。", submitFailed: "提交失败。请重试。", inquiryReceived: "已收到咨询。我们将在 2–3 小时内回复。" },
  },
  footer: {
    blurb: "DC Dashboard — 一站式媒介购买。代理广告账户、预付钱包,以及在每个主要渠道的统一活动管理。香港制造。全球运营。",
    institutionalUpdates: "机构更新",
    newsletterHelp: "季度简报。无垃圾。随时取消订阅。",
    subscribe: "订阅",
    placeholderEmail: "name@company.com",
    solutions: "仪表板", markets: "市场", company: "公司",
    submitInquiry: "提交咨询",
    rights: "保留所有权利。",
    legal: "香港特别行政区注册 · 合规 · 不保证绩效。",
    enterEmailToast: "请输入有效的电子邮件地址。",
    couldNotSubscribe: "无法订阅。请重试。",
    subscribed: "已订阅。",
    links: { dashboard: "DC Dashboard", masterAccounts: "主广告账户", oneWallet: "一个钱包,多个渠道", txnReporting: "交易与报告", howItWorks: "运作方式", pricing: "价格", sea: "东南亚", emea: "欧洲与美洲", jpkr: "日本与韩国", latam: "拉丁美洲", mena: "中东与非洲", whyDc: "为何选择 Danny Clans", industries: "行业", insights: "博客", contact: "联系", admin: "管理" },
  },
  pages: {
    insightsTitle: "为运营者和 CMO 打造的跨境增长洞察。",
    insightsSubtitle: "关于全球扩张、增长营销和合规的实战经验 — 为运营者和 CMO 撰写。",
    insightsEmpty: "新文章即将推出。请稍后回来查看。",
    insightNotFound: "未找到文章", insightNotFoundDesc: "可能已移动或取消发布。", allInsights: "所有文章", insightCategory: "博客",
    engagementTitle: "DC Dashboard 工作方式 — 5 步跨境入职流程。",
    engagementSubtitle: "从注册到规模化活动 — 有文档记录、可重复的入职路径。透明、预付、审计就绪。",
    pricingTitle: "代理广告账户价格 — 五个方案,一个仪表板。",
    pricingSubtitle: "Launch (免费) 到 Media Buyer Scales++ ($15,000/月企业)。选择匹配您运营强度的级别。",
    dashboardTitle: "DC Dashboard — 代理广告账户。一个钱包。所有渠道。",
    dashboardSubtitle: "在每个主要平台申请代理广告账户,为单一预付钱包充值,从一个控制台运行活动,并从实时交易账本报告。",
    localizationTitle: "区域原生广告活动 — 东南亚、欧美、日韩、拉美和中东非洲。",
    localizationSubtitle: "每个地区都是平台、支付、语言和法律的独特系统。切换地区以查看我们如何在当地建立市场进入和增长运营。",
    industriesTitle: "面向品牌、游戏、应用和电商的跨境增长系统。",
    industriesSubtitle: "品牌、游戏、应用和电商运营者各自需要不同的增长引擎。我们以同样的治理纪律设计所有四个。",
    aboutTitle: "Danny Clans Media — 香港跨境增长合作伙伴。",
    aboutSubtitle: "Danny Clans Media 是全球品牌、游戏工作室、应用业务和电商运营者的机构级跨境增长合作伙伴 — 成立宗旨是为长期以过度承诺闻名的行业带来合规导向的基础设施。",
  },
  seo: {
    breadcrumbHome: "首页",
    home: {
      metaTitle: "Meta、Google 和 TikTok 代理广告账户 | 一个钱包",
      metaDescription: "获取 Meta、Google、TikTok、Bing、Snap、LinkedIn 等平台的代理级广告账户 — 由单一预付钱包提供资金。香港特区注册。",
      keywords: "代理广告账户, Meta 广告账户, Google 广告代理, TikTok 广告账户, 跨境广告, 媒介购买平台, 一个钱包广告平台, DC Dashboard",
      breadcrumbLabel: "首页",
      ogTitle: "您的广告。我们的基础设施。",
      ogDescription: "接入 15+ 广告平台。零停机。一个钱包。从一个仪表板管理 Meta、Google、TikTok 等所有主流平台。",
      imageAlt: "Danny Clans DC Dashboard — 一个钱包,每个广告平台(Meta、Google、TikTok 等)。",
    },
    dashboard: {
      metaTitle: "DC Dashboard — 代理广告账户,一个钱包,所有渠道",
      metaDescription: "在 Meta、Google、TikTok、Bing、LinkedIn、YouTube 等平台开通代理广告账户。为一个钱包充值。从统一控制台管理每个活动。",
      keywords: "代理广告账户, 媒介购买仪表板, 预付广告钱包, 多渠道广告管理, Meta 代理账户, TikTok 代理账户",
      breadcrumbLabel: "仪表板",
    },
    pricing: {
      metaTitle: "代理广告账户价格 — 5 个方案,从免费到企业",
      metaDescription: "Meta、Google、TikTok 等平台代理广告账户的透明月度价格 — Launch (免费)、Growth $300、Scale $500、Dominance $1,000、企业级。",
      keywords: "代理广告账户价格, Meta 广告账户费用, TikTok 代理账户价格, 媒介购买价格方案, DC Dashboard 价格",
      breadcrumbLabel: "价格",
    },
    about: {
      metaTitle: "关于 Danny Clans Media — 香港跨境增长合作伙伴",
      metaDescription: "Danny Clans Media 是香港特区注册的跨境增长合作伙伴,服务于全球品牌、游戏工作室、应用和电商。合规优先。",
      keywords: "Danny Clans Media, 香港广告代理, 跨境增长合作伙伴, 合规优先媒介购买, 香港特区注册",
      breadcrumbLabel: "关于",
    },
    contact: {
      metaTitle: "联系 Danny Clans Media — 获取代理广告账户访问权限",
      metaDescription: "提交专业咨询,获取 DC Dashboard 访问权限、代理广告账户开通和跨境增长服务。直接、保密 — 2–3 小时回复。",
      keywords: "联系 Danny Clans, 代理广告账户访问, 专业咨询, 跨境媒介购买咨询",
      breadcrumbLabel: "联系",
    },
    industries: {
      metaTitle: "面向品牌、游戏、应用和电商的跨境增长",
      metaDescription: "面向全球品牌、游戏工作室、应用业务和电商运营者的垂直跨境增长系统 — 由 DC Dashboard 开通。",
      keywords: "跨境增长, 品牌营销代理, 游戏用户获取, 移动应用 UA, 电商跨境广告",
      breadcrumbLabel: "行业",
    },
    localization: {
      metaTitle: "区域原生广告活动 — 东南亚、欧美、日韩、拉美和中东非洲",
      metaDescription: "针对东南亚、欧美、日韩、拉美和中东非洲的区域原生跨境广告手册。本地化账户与支付。",
      keywords: "区域原生广告, 东南亚广告, 拉美媒介购买, 日韩广告账户, 中东非洲广告, 跨境本地化",
      breadcrumbLabel: "本地化",
    },
    engagement: {
      metaTitle: "DC Dashboard 工作方式 — 5 步跨境入职流程",
      metaDescription: "从注册到规模化多渠道活动的五个有文档记录的步骤。透明、预付、审计就绪 — Danny Clans 运营原则。",
      keywords: "DC Dashboard 工作方式, 跨境入职, 媒介购买入职, 预付广告钱包设置, 代理账户开通",
      breadcrumbLabel: "运作方式",
    },
    blog: {
      metaTitle: "博客 — 跨境增长、广告和合规洞察",
      metaDescription: "关于跨境增长营销、代理广告账户和合规的实战洞察 — 为运营者、CMO 和代理商负责人撰写。",
      keywords: "跨境营销博客, 代理广告账户洞察, 增长营销博客, 广告合规洞察, 媒介购买博客",
      breadcrumbLabel: "博客",
    },
  },
  common: {
    whatsappCta: "WhatsApp 咨询",
    whatsappPrefill: "您好 Danny Clans,我想了解 DC Dashboard 和代理广告账户访问。",
    mostPopular: "最受欢迎", limitations: "限制", included: "包含",
    primaryChannels: "主要渠道", localPlaybook: "本地手册", priorityMarkets: "优先市场",
    marketEntryChecklist: "市场进入清单", standardEnterprise: "标准方案 · 企业级自定义",
    enterpriseWhitelabel: "企业 · 白标",
    whatWeWillNotDoTitle: "我们不会做的事",
    whatWeWillNotDoItems: ["保证特定的 ROAS、CPA 或活动绩效。", "在非预付安排或未披露利润下运营。", "为短期利益绕过平台政策或监管要求。"],
    governedCapability: "{{module}} — 受管能力",
    governedBody: "每项能力都配有政策对齐、审计日志和标准化报告。可靠性是一个功能,而非升级。",
    governedBullets: ["有文档的标准操作", "符合平台政策", "白标就绪 (Media Buyer Scales++)"],
    paymentNote: "美元计价钱包。资金到达主余额,可部署到任何连接的广告渠道。",
    stepLabel: "步骤",
    transparentLimits: { title: "透明的服务限制", body: "我们提供基础设施和合规框架。我们不保证活动绩效、广告审批率或账户寿命。我们的重点是可靠的系统、治理和可衡量的过程 — 而非承诺。", items: ["可靠系统优先", "有文档的服务范围", "无激进销售", "无隐藏利润"] },
    industryEngages: { title: "Danny Clans 介入的地方", items: ["策略与市场选择", "账户与实体开通", "服务器端跟踪与归因", "本地化创意制作", "24/7 媒介运营与治理"], note: "我们提供基础设施和合规框架。我们不保证活动绩效、广告审批率或账户寿命。" },
    marketEntryItems: ["法律实体与税务审核", "KYC 与账户开通", "服务器端跟踪设置", "品牌与创意本地化", "本地支付与结账", "合规与内容审核", "启动治理计划"],
  },
  content: {
    screenshots: {
      display: { title: "一个仪表板,所有渠道", desc: "在单一控制台管理 Meta、Google、TikTok、Bing、Snap、LinkedIn、YouTube、Outbrain、Taboola、Naver、LINE。" },
      wallet:  { title: "钱包与交易", desc: "实时钱包余额、可搜索的交易账本和审计就绪的导出。" },
      deposit: { title: "存款与支付", desc: "银行转账、Visa/Mastercard、UPI 或 稳定币 — 为钱包充值,为每个广告渠道充值。" },
      console: { title: "主控制台预览", desc: "DC Dashboard 工作区的完整视图 — 钱包、账本、警报和多账户控制在一个统一视图中。" },
    },
    featureBullets: { liveData: "实时数据", auditExports: "审计就绪导出", multiCurrency: "多币种支持", roleAccess: "基于角色的访问 (Scale+)" },
    dashboardFeatures: {
      master:   { code: "主广告账户", title: "申请代理广告账户", description: "在 Meta、Google、TikTok、Bing、Snap、LinkedIn、YouTube、Outbrain、Taboola、ByteDance、Kuaishou、LINE、Naver 申请并开通代理级广告账户。我们处理 KYC、合规文档和入职,让您更快开始投放。", bullets: ["单一申请流程", "处理 KYC 与合规", "多平台开通", "每渠道状态跟踪"] },
      oneWallet:{ code: "一个钱包", title: "集中预付钱包", description: "为单一 Danny Clans 钱包充值,然后在几秒内将预算部署到任何渠道 — 无需单独的平台存款。接受银行转账、Visa/Mastercard、UPI、INR 钱包或 Stablecoins。", bullets: ["美元计价余额", "银行、卡、UPI、稳定币", "即时资金部署", "更低的 B2B 充值费率"] },
      campaign: { code: "活动控制", title: "在所有渠道运行活动", description: "从一个仪表板启动、编辑、暂停和调整每个连接平台的活动。跨平台预算分配、账户级控制和统一治理。", bullets: ["多平台活动启动", "跨平台预算转移", "账户级控制", "工作流自动化 (更高级别)"] },
      reports:  { code: "交易与报告", title: "审计就绪的交易账本", description: "每次充值、每次渠道借记、每次活动支出 — 可搜索、可过滤、可导出。为财务、董事会和合规审计而建,而不仅仅是营销仪表板。", bullets: ["实时交易日志", "按邮箱/TxnID 搜索", "类型与状态过滤器", "自定义报告 (Dominance+)"] },
      support:  { code: "支持与合规", title: "合规优先,人工支持", description: "每个方案都有标准合规文档。仪表板内聊天帮助、WhatsApp/Telegram 支持群、专属客户经理,以及随规模扩展的快速 SLA 级别。", bullets: ["标准合规文档", "仪表板内聊天支持", "WhatsApp/Telegram 群", "专属经理 (Scale+)"] },
    },
    advantages: {
      agencyAccess:        { title: "代理级访问", description: "每个主要平台的官方授权代理广告账户 — 无需自行 KYC 折磨。" },
      oneWalletMany:       { title: "一个钱包,多个渠道", description: "为一个余额充值。立即在 Meta、Google、TikTok、Bing 和所有原生网络上花费。" },
      complianceBuiltIn:   { title: "内置合规", description: "每个方案的标准合规文档、KYC 和平台政策对齐。" },
      b2bRates:            { title: "B2B 充值费率", description: "随着规模扩大,充值费率更低。Media Buyer Scales++ 级别提供企业 B2B 费率。" },
      transparentReporting:{ title: "透明报告", description: "实时交易账本、审计就绪导出和董事会级治理的自定义报告。" },
      hkOperated:          { title: "香港制造,全球运营", description: "战略性特区注册提供全球合规运营与机构级信誉。" },
    },
    regions: {
      sea:   { label: "东南亚", headline: "从雅加达到马尼拉 — 世界上最年轻的商业引擎。", summary: "移动优先,超级应用驱动,对价格敏感。从一个钱包并行运行 TikTok、Meta、Google 和 LINE 活动。", markets: ["印度尼西亚", "越南", "菲律宾", "泰国", "马来西亚", "新加坡"], playbook: ["一个应用中的多平台代理账户", "多语言创意 (印尼语、越南语、菲律宾语、泰语)", "本地支付充值 (UPI、Stablecoins、银行)", "市场 + DTC 双轨"] },
      emea:  { label: "欧洲与美洲", headline: "高端市场奖励治理与品牌深度。", summary: "高 CPM,成熟的买家,严格的隐私制度。我们在 Meta、Google、YouTube、LinkedIn 和 Reddit 上设计合规优先的增长。", markets: ["美国", "加拿大", "英国", "德国", "法国", "西班牙"], playbook: ["GDPR/CCPA 合规文档", "所有主要平台的高级代理账户", "品牌安全的创意治理", "通过市场渠道的零售媒体"] },
      jpkr:  { label: "日本与韩国", headline: "质量、工艺与文化流畅性 — 须赚取,非购买。", summary: "富裕、注重品牌。渠道集中 (LINE、Kakao、Naver、Yahoo JP)。本地化代理账户解锁这些封闭生态系统。", markets: ["日本", "韩国"], playbook: ["原生 LINE 与 Naver 账户", "本地语言合规文档", "每个创意的文化 QA", "高端定位"] },
      latam: { label: "拉丁美洲", headline: "爆炸性移动增长遇上碎片化的支付与文化。", summary: "巴西和墨西哥是该地区的支柱。我们按国家本地化代理设置、支付通道和创意组合。", markets: ["巴西", "墨西哥", "哥伦比亚", "阿根廷", "智利"], playbook: ["葡萄牙语与西班牙语创意", "WhatsApp + Pix 转化漏斗", "原生广告网络 (Taboola、Outbrain)", "跨境物流就绪"] },
      mena:  { label: "中东与非洲", headline: "高 AOV、移动原生、视频优先的市场。", summary: "海合会推动高端 AOV;非洲移动优先且创作者主导。从一个钱包进行多语言活动。", markets: ["阿联酋", "沙特阿拉伯", "埃及", "尼日利亚", "南非"], playbook: ["RTL 阿拉伯语创意系统", "多币种充值", "Snap 与 TikTok 创作者计划", "监管与文化审核"] },
    },
    industries: {
      brand:  { label: "品牌走向全球", headline: "在国内市场之外建立品类领导地位。", summary: "在每个相关广告渠道整合品牌 + 绩效活动 — 从一个仪表板管理。", bullets: ["多市场品牌活动", "高级代理账户", "中漏斗绩效品牌", "包含合规文档"] },
      gaming: { label: "游戏走向全球", headline: "在平台和商店中大规模获取盈利玩家。", summary: "从软启动到全球扩展:从一个钱包部署 Meta、TikTok、YouTube、Bing UA 活动。", bullets: ["软启动与地理扩展", "多平台 UA 竞价", "审计就绪的支出跟踪", "专属专家 (Dominance+)"] },
      apps:   { label: "应用走向全球", headline: "按市场设计订阅和参与增长。", summary: "对于金融、工具、内容和 AI 应用 — 跨平台 UA 从一个控制台,带完整交易账本。", bullets: ["跨平台 UA", "实时订阅支出跟踪", "跨地区定价策略", "群组分析支持"] },
      ecom:   { label: "电商走向全球", headline: "DTC 和市场的转化级基础设施。", summary: "DTC、Shopify、Amazon、Shopee、Lazada、MercadoLibre — 一个钱包资助所有。", bullets: ["DTC + 市场双轨", "多币种充值", "渠道级支出日志", "跨境物流就绪"] },
    },
    whyReasons: {
      noGuarantees:     { title: "不保证绩效", description: "我们构建基础设施,而非承诺。可靠的系统和合规框架 — 从不夸大指标。" },
      complianceFirst:  { title: "合规优先方法", description: "监管对齐是我们的竞争优势。每项服务都围绕平台政策和法律设计。" },
      expertToExpert:   { title: "专家对专家沟通", description: "为负责人和 CMO 而建。无需手把手指导,无激进销售。直接、技术性、有节制。" },
      transparentCost:  { title: "透明成本结构", description: "预付模式。无隐藏利润。随着规模扩大,更低的 B2B 充值费率。" },
      hkJurisdiction:   { title: "香港注册实体", description: "战略性特区注册提供全球全球合规运营与机构级信誉。" },
      whiteLabel:       { title: "白标基础设施", description: "代理商在我们的 Media Buyer Scales++ 级别将 DC Dashboard 作为自己的品牌。" },
    },
    institutionalProofs: {
      hkIncorp:         { title: "香港特别行政区注册", description: "注册业务实体 (Danny Clans Media Limited),在 HK 司法管辖下完全合规。" },
      multiPlatform:    { title: "多平台账户访问", description: "直接工作访问 Meta、Google、TikTok、Bing、Snap、LinkedIn 等 — 通过我们的主代理堆栈开通。" },
      complianceOps:    { title: "合规优先的运营", description: "对每个开设的账户进行内部审查 — 政策对齐、计费卫生和平台级入职。" },
      transparentLimits:{ title: "透明的限制", description: "我们不保证活动绩效、广告审批率或账户寿命。" },
    },
    paymentMethods: { bankUsd: "银行转账 · SWIFT · 电汇 (美元)", visa: "Visa / Mastercard", upi: "UPI (印度)", inrWallet: "INR 本地钱包", usdt: "Stablecoins" },
    services: { launch: "DC Dashboard – Launch (免费)", growth: "DC Dashboard – Growth", scale: "DC Dashboard – Scale", dominance: "DC Dashboard – Dominance", enterprise: "Media Buyer Scales++ (企业)", provisioning: "代理广告账户开通", walletHelp: "钱包充值与支付帮助", whiteLabel: "白标 / 代理合作", complianceConsult: "合规与政策咨询" },
    pricing: {
      launch:     { name: "Launch", tagline: "零风险测试平台。", target: "独立媒介购买者和验证跨境广告的企业。", includes: ["单一平台账户开通", "标准合规文档", "聊天板帮助 (通过仪表板)", "基本技术集成支持", "任何 1 个平台访问 (Meta / Google / TikTok)"], limits: ["无法获得多平台访问", "URL 和内容需要审批", "每月最多 5 个广告账户", "支持在 24 小时内响应"], cta: "从 Launch 开始" },
      growth:     { name: "Growth", tagline: "在真实支持下运行多渠道活动。", target: "超越单一渠道的成长型企业。", includes: ["多平台账户开通", "WhatsApp / Telegram 支持群", "12 小时响应时间", "基本技术集成支持", "跨平台预算分配", "广告账户入职指南"], limits: ["无原生广告平台访问", "充值费用低于 Launch", "每月最多 20 个广告账户"], cta: "选择 Growth" },
      scale:      { name: "Scale", tagline: "所有平台、专属经理、优先 SLA。", target: "在所有主要渠道运营的扩展品牌和代理商。", includes: ["所有平台账户开通 (含原生)", "WhatsApp / Telegram 支持群", "优先支持 (~8 小时响应)", "专属客户经理", "访问所有平台"], limits: ["无专属策略师", "标准合规文档", "邮件支持 48 小时响应", "每月最多 40 个广告账户"], cta: "选择 Scale" },
      dominance:  { name: "Dominance", tagline: "机构级服务、完全合规、无限账户。", target: "需要最强标准级别的机构广告主。", includes: ["Scale 中的所有内容,加:", "快速支持 (1–2 小时响应)", "专属广告专家", "创意制作支持", "广告优化咨询 (每月 4 小时)", "无限广告账户", "战略活动评审", "自定义报告", "自定义工作流与 AI 工具设置", "快速账户开通"], limits: [], cta: "选择 Dominance" },
      mediabuyer: { name: "Media Buyer Scales++", tagline: "我们扩展别人无法扩展的。", target: "大型代理商、媒介购买组织,以及在多个品牌和地区管理大规模支出的企业广告主。", includes: ["Dominance 中的所有内容,加:", "白标报告套件 (代理品牌)", "更低的充值费用 (B2B 费率)", "优先企业定价", "优先支付处理", "合并账单选项", "基于数量的折扣", "企业信贷设施 (需审批)", "客户入职协助", "代理扩展咨询", "代理流程优化", "团队培训会议", "SOP 开发指导", "客户保留策略评审", "增长机会评估", "收入扩展咨询"], limits: [], cta: "联系企业" },
    },
    pricingFaqs: [
      { q: "价格固定吗?", a: "标准方案 (Launch / Growth / Scale / Dominance) 是固定的月费。Media Buyer Scales++ 是自定义企业合作。" },
      { q: "月费包含广告预算吗?", a: "不。月费涵盖平台访问、账户开通、支持和仪表板使用。广告预算单独充值到您的钱包并部署到广告账户。" },
      { q: "您接受哪些支付方式?", a: "银行转账 · SWIFT · 电汇 (美元)、Visa/Mastercard、UPI (印度)、INR 本地钱包和 Stablecoins。" },
      { q: "我可以升级或降级吗?", a: "可以。随时从仪表板升级。降级在下一个计费周期生效。" },
      { q: "什么是 'B2B 充值费率'?", a: "将资金从主钱包转移到广告平台账户时应用的较低费用。在 Growth (略低于 Launch) 和 Media Buyer Scales++ 享有最优惠的费率。" },
    ],
    dashboardFaqs: [
      { q: "DC Dashboard 支持哪些广告渠道?", a: "Meta、Google、TikTok、YouTube、Bing、LinkedIn、Snapchat、X (Twitter)、Reddit、Pinterest、ByteDance、Kuaishou、LINE、Naver、Outbrain、Taboola — 我们随运营者需求扩展。" },
      { q: "我多快能获得代理账户?", a: "标准开通在入职期间进行。快速开通在 Dominance 和 Media Buyer Scales++ 级别提供。" },
      { q: "如何为钱包充值?", a: "银行转账 · SWIFT · 电汇 (美元)、Visa/Mastercard、UPI、INR 本地钱包或 Stablecoins。资金清算到您的美元主余额,可部署到任何连接的渠道。" },
      { q: "您保证活动绩效吗?", a: "不。我们提供合规的基础设施、代理账户、钱包和报告。我们不保证绩效、广告审批或账户寿命。" },
      { q: "代理商可以白标仪表板吗?", a: "可以。Media Buyer Scales++ 级别包括以您的代理商品牌定制的白标报告套件、B2B 充值费率和代理增长服务。" },
    ],
    onboardingSteps: {
      signup: { title: "注册与验证", desc: "创建 Danny Clans 账户并完成 KYC。合规文档由我们处理。" },
      plan:   { title: "选择方案", desc: "Launch (免费)、Growth、Scale、Dominance 或 Media Buyer Scales++。随时升级。" },
      apply:  { title: "申请广告账户", desc: "在 Meta、Google、TikTok、Bing、Snap、LinkedIn、YouTube、Outbrain、Taboola 等申请代理账户。" },
      topup:  { title: "为钱包充值", desc: "通过银行转账、信用卡、UPI 或 Stablecoins 为单一美元钱包充值。更高级别享更低的 B2B 费率。" },
      launch: { title: "启动与扩展", desc: "将预算部署到任何渠道,监控实时交易,并以优先 SLA + 专属专家扩展。" },
    },
    engagementPrinciples: {
      prepaid:    { title: "预付,非聘用", desc: "您预先为合作充值;我们根据有文档的项目提取。钱包余额始终可见。" },
      scope:      { title: "有文档的范围", desc: "每个方案、可交付成果、渠道和 SLA 在启动前都有文档。方案变更以书面形式记录。" },
      compliance: { title: "合规导向", desc: "每个方案的标准合规文档。我们将拒绝引入不可接受风险的范围。" },
      auditReady: { title: "审计就绪", desc: "每笔交易都被记录。报告标准化。您的财务、合规或董事会可以审计任何钱包。" },
    },
    engagementWho: { title: "DC Dashboard 为谁打造", items: ["在国内市场之外扩展的跨境品牌", "需要可预测 UA 基础设施的游戏工作室", "瞄准全球增长的应用和订阅业务", "运营 DTC + 市场双轨的电商运营者", "需要白标跨境基础设施的代理商 (Media Buyer Scales++)"] },
    engagementWhoNot: { title: "我们不与谁合作", lead: "透明胜于转化。我们拒绝不合适的合作:", items: ["受平台政策或法律限制的类别", "寻求保证活动绩效的客户", "没有预付资金结构的合作", "需要未披露利润或政策外策略的项目"] },
    aboutPrinciples: {
      compliance:     { title: "合规是一项功能", desc: "平台政策、司法监管和品牌安全从第一天就设计到每个系统中 — 不会在事后修补。" },
      infrastructure: { title: "基础设施胜于承诺", desc: "我们承诺流程、治理和报告。我们不承诺具体的绩效指标。" },
      documented:     { title: "有文档且审计就绪", desc: "每个动作都被记录。每个成本都被记录。每个变更都可审查。机构合作伙伴需要机构纪律。" },
      expert:         { title: "专家对专家", desc: "我们与营销负责人、CMO 和运营者合作 — 而非消费者潜在客户。沟通技术性、直接且有节制。" },
    },
  },
};
export default zh;
